<template>
  <div class="education-center__content">
    <news-list
      :news-list="topSectionList"
      :video-settings="videoSettings"
      v-on="$listeners"
    />

    <a-banner
      :banner-settings="BANNER_SETTINGS.EDUCATION_CATEGORY.MIDDLE_BANNER"
      class="education-center__banner middle"
    />

    <div v-if="isBottomSectionIncludesArticles">
      <news-list :news-list="bottomSectionList" v-on="$listeners" />

      <a-lazy-hydrate when-visible>
        <a-banner
          :banner-settings="BANNER_SETTINGS.EDUCATION_CATEGORY.BOTTOM_BANNER"
          class="education-center__banner bottom"
        />
      </a-lazy-hydrate>
    </div>
  </div>
</template>

<script>
import NewsList from './NewsList'
import ABanner from 'shared/ABanner'
import { BANNER_SETTINGS } from 'enums/banners/banner-settings'
import { propValidator, PROP_TYPES } from '@/utils/validators'

export default {
  name: 'EducationNewsList',
  components: { NewsList, ABanner },
  props: {
    newsList: propValidator([PROP_TYPES.ARRAY]),
    videoSettings: propValidator([PROP_TYPES.OBJECT], false)
  },
  data() {
    return { BANNER_SETTINGS }
  },
  computed: {
    isVideoIncluded() {
      return !!this.videoSettings
    },
    topSectionList() {
      const end = this.isVideoIncluded ? 4 : 8
      return this.newsList.slice(0, end)
    },
    bottomSectionList() {
      const start = this.isVideoIncluded ? 4 : 8
      return this.newsList.slice(start)
    },
    isBottomSectionIncludesArticles() {
      return !!this.bottomSectionList.length
    }
  }
}
</script>

<style lang="scss" scoped>
.education-center__content {
  .education-center__banner {
    margin-top: 40px;
    margin-bottom: 40px;

    @include mobile {
      margin-top: 0;
      margin-bottom: 30px;
    }
  }
}
</style>
